import initIntercom, {
  shutdown as shutdownIntercom,
  startConversation as startIntercomConversation
} from "@intercom/messenger-js-sdk";

export default class Intercom {
  static init(settings) {
    initIntercom(settings);
  }

  static startConversation(message) {
    if (window.Intercom) startIntercomConversation(message);
  }

  static shutdown() {
    if (window.Intercom) shutdownIntercom();
  }
}
